<template>
	<div class="client-area-login">
		<invalid-modal ref="invalidModal"/>
		<span class="client-area-login__accent" aria-hidden="true"></span>
		<h1>{{tranlationTitle}}</h1>
		<form class="client-area-login__form" @submit.prevent="confirmLogin">
			<input class="client-area-login__input" v-model="client.login" :placeholder="translation.user" required>
			<input class="client-area-login__input" type="password" v-model="client.password" :placeholder="translation.pass" required>
			<button class="client-area-login__button" type="submit">
				{{translation.enter}}
			</button>
		</form>
	</div>
</template>
<script>
import { translate } from '../../assets/translations';
import InvalidModal from '../shared/InvalidModal.vue';
import EventService from '../../services/EventService';

export default {
	components: {
		InvalidModal
	},
	computed: {
		translation() {
			return translate(this.$store.state.language).loginArea;
		},
		tranlationTitle() {
			return translate(this.$store.state.language).navbar.clientsArea;
		}
	},
	data() {
		return {
			client: {},
			eventService: new EventService(),
		}
	},
	mounted() {
		this.client = {
			login:'',
			password :''
		}
	},
	methods: {
		confirmLogin() {
			this.eventService.sendLogin({login: this.client.login, password: this.client.password}).then( res => {
				let event = {
					...res.data,
					statusLogin: true
				}
				this.$store.commit("event", event);
				this.$emit('validateLogin', event);
			}).catch(() => {
				this.$refs.invalidModal.open(this.translation.error.title, this.translation.error.message);
			}).finally(()=> {
				this.cleanLogin();
			})
		},
		cleanLogin() {
			this.client = {
				login: '',
				password: ''
			};
		}
	}
}
</script>
<style scoped lang="scss">
.client-area-login {
	box-sizing: border-box;
	width: 100%;
	max-width: 650px;
	margin: 0 auto;
	padding: 48px 56px 54px;
	border-radius: 30px;
	background: #eeeeee;
	color: #5a5a5a;
}

.client-area-login__accent {
	display: block;
	width: 44px;
	margin-bottom: 18px;
	border-top: 4px solid #e89127;
}

.client-area-login h1 {
	margin: 0 0 34px;
	color: #002c41;
	font-size: 30px;
	font-weight: 700;
	line-height: 36px;
}

.client-area-login__form {
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.client-area-login__input {
	box-sizing: border-box;
	width: 100%;
	height: 58px;
	padding: 0 20px;
	border: 1px solid rgba(0, 0, 0, .2);
	border-radius: 10px;
	background: #ffffff;
	color: #5a5a5a;
	font-family: inherit;
	font-size: 18px;
	font-weight: 400;
	line-height: 18px;
	outline: none;
	box-shadow: none;
}

.client-area-login__input::placeholder {
	color: #5a5a5a;
	opacity: 1;
}

.client-area-login__input:focus {
	border-color: #66acc6;
	box-shadow: 0 0 0 .2rem rgba(102, 172, 198, .15);
}

.client-area-login__button {
	box-sizing: border-box;
	width: 200px;
	height: 40px;
	margin: 16px 0 0 auto;
	border: 1px solid #ff9600;
	border-radius: 10px;
	background: #ff9600;
	color: #ffffff;
	font-family: inherit;
	font-size: 16px;
	font-weight: 700;
	line-height: 19px;
	box-shadow: 4px 4px 100px rgba(0, 0, 0, .1);
	cursor: pointer;
}

.client-area-login__button:hover,
.client-area-login__button:focus-visible {
	background: #e89127;
}

@media (max-width: 600px) {
	.client-area-login {
		padding: 36px 22px 42px;
		border-radius: 20px;
	}

	.client-area-login h1 {
		font-size: 26px;
		line-height: 32px;
	}

	.client-area-login__input {
		font-size: 16px;
	}

	.client-area-login__button {
		width: 100%;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/clients-area/ClientsAreaLogin.vue